/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import { IXC_ASSETS_V1_ASSET_COMMAND_SERVICE_GET_LOGO_AUDIENCE, ixcAssetsV1AssetCommandServiceGetLogo } from '@interxfi/api-client/generated/client-functions/ixc-assets-v1-asset-command-service-get-logo';
import type { IxcAssetsV1AssetCommandServiceGetLogoGetLogoRequest, IxmUserauthV1JoinedRealmAccess, IxmUserauthV1RealmState } from '@interxfi/types';
import { type DefinedInitialDataOptions, queryOptions, useQuery } from '@tanstack/react-query';
import { withAuthorizationToken } from '../../api-client';
import { useRealmAuthActiveAccess, useRealmAuthIsAuthenticated } from '../../context';
import { type TenantContext, useRealmAPIContext } from '../../realm-context';

/**
 * @generated by NormalizedQueryPlugin (get /ixc/assets/v1/asset/c/:assetId/logo) */

export function buildIxcAssetsV1AssetCommandServiceGetLogoKey(request?: IxcAssetsV1AssetCommandServiceGetLogoGetLogoRequest) { return ['ixc.assets.v1.AssetState', 'detail', request] as const; }

export function buildIxcAssetsV1AssetCommandServiceGetLogoQueryOptions(baseUrl: string | undefined, isAuthenticated: boolean, token: string | undefined, realm: IxmUserauthV1RealmState | undefined, tenantContext: TenantContext | undefined, extendKey: any, request: IxcAssetsV1AssetCommandServiceGetLogoGetLogoRequest | undefined, options?: Partial<DefinedInitialDataOptions<undefined>>) { return queryOptions({
    queryKey: extendKey(buildIxcAssetsV1AssetCommandServiceGetLogoKey(request)),
    queryFn: async () => ixcAssetsV1AssetCommandServiceGetLogo(baseUrl, request, withAuthorizationToken(token)),
    enabled: Boolean(isAuthenticated && token && realm && request?.assetId && tenantContext && IXC_ASSETS_V1_ASSET_COMMAND_SERVICE_GET_LOGO_AUDIENCE.includes(tenantContext)),
    ...options
}); }

export function useIxcAssetsV1AssetCommandServiceGetLogo(request: IxcAssetsV1AssetCommandServiceGetLogoGetLogoRequest | undefined, options?: Partial<DefinedInitialDataOptions<undefined>>, withAccess?: IxmUserauthV1JoinedRealmAccess) {
    const isAuthenticated = useRealmAuthIsAuthenticated();
    const activeAccess = useRealmAuthActiveAccess();
    const { realm, baseUrl, extendKey, token, tenantContext } = useRealmAPIContext(withAccess ?? activeAccess);
    
    return useQuery(buildIxcAssetsV1AssetCommandServiceGetLogoQueryOptions(baseUrl, isAuthenticated, token, realm, tenantContext, extendKey, request, options));
}
